import { apiSlice } from "app/api/apiSlice";

export const helpApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPrivacyPolicy: builder.query({
      query: (query) => {
        return {
          url: "/tos/privacy_policy/",
        };
      },
      transformResponse: (response) => {
        if (!response.success) {
          throw new Error("Error fetching privacy policy");
        }
        return response.data;
      },
    }),
    getCommunityGuidelines: builder.query({
      query: (query) => {
        return {
          url: "/tos/community_guideline/",
        };
      },
      transformResponse: (response) => {
        if (!response.success) {
          throw new Error("Error fetching Community Guidelines");
        }
        return response.data;
      },
    }),
    getTermsOfService: builder.query({
      query: (query) => {
        return {
          url: "/tos/terms_of_service/",
        };
      },
      transformResponse: (response) => {
        if (!response.success) {
          throw new Error("Error fetching terns of services");
        }
        return response.data;
      },
    }),
    getRefundPolicy: builder.query({
      query: (query) => {
        return {
          url: "/tos/refund_policy/",
        };
      },
      transformResponse: (response) => {
        if (!response.success) {
          throw new Error("Error fetching Refund Policy");
        }
        return response.data;
      },
    }),
  }),
});

export const {
  useGetPrivacyPolicyQuery,
  useGetCommunityGuidelinesQuery,
  useGetTermsOfServiceQuery,
  useGetRefundPolicyQuery,
} = helpApiSlice;
